import { Clear } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import EmployeeSearch, {
  employeeSearchResultinitialState,
} from "components/Common/EmployeeSearch/EmployeeSearch";
import DataNitivSyncIcon from "components/Common/DataNitivSyncIcon/DataNitivSyncIcon";
import TextLabel from "components/Common/TextLabel/TextLabel";
import { isStringNullOrEmpty } from "components/Common/utilities";
import {
  CustomButton,
  CustomTooltip,
} from "components/RosterConfig/RosterConfigStyle";
import SnackBar from "components/SnackBar/SnackBar";
import BackdropComponent from "components/Spinner/Spinner";
import { parseInt } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  createClassRequest,
  getProjectDetails,
  getSiteLocatioins,
  postClassRequest,
} from "services/userServices";
import { classRequestActions } from "Store/ClassRequest";
import { SnackBarStoreAction } from "Store/SnackBar";
import pillThemeConfig from "styles/pillThemeConfig";

const prepareChipStyle = (label) => ({
  fontSize: "14px",
  fontWeight: "bold",
  letterSpacing: "1px",
  backgroundColor: pillThemeConfig[label]?.primaryColor,
  color: pillThemeConfig[label]?.fontColor,
});

const prepareChipToolTypeTitle = (text) => (
  <Typography variant="body2" sx={{ fontSize: "1rem" }}>
    {text}
  </Typography>
);

const hexToRgba = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
//Sorted in Alphabetical order
const classTypeOptions = [
  "Attrition",
  "Attrition - Conversion",
  "New Launch",
  "New Launch - Conversion",
  "Seasonal Growth",
  "Seasonal Growth - Conversion",
  "Steady State Growth",
  "Steady State Growth - Conversion",
];

const trainingProductionOptions = [
  "New Hire - @Home Dedicated",
  "New Hire - B&M Dedicated",
  "New Hire - Train @Home,Production Onsite",
  "New Hire - Train B&M,Production @Home",
  "New Hire/Transfer Combination - Train @Home,Production Onsite",
  "New Hire/Transfer Combination - Train B&M,Production @Home",
  "Change Role - @Home Dedicated",
  "Change Role - B&M Dedicated",
  "Change Role - B&M to @Home Migration",
  "Change Role - Client to Client Transfer",
  "Change Role - Technology/Project Change",
];

const trainingClassificationOptions = ["PT", "FT"];
const productionClassificationOptions = [
  "PT Regular",
  "PT Temporary",
  "FT Regular",
  "FT Temporary",
];
const requestStatusOptions = [
  "In Progress",
  "On Hold",
  "Closed",
  "Cancelled",
  "Extended Training/Nesting - Full",
  "Extended Training/Nesting - Partial",
];

const ogOptions = [
  {
    id: 1,
    name: "OG",
  },
  {
    id: 2,
    name: "FDO",
  },
  {
    id: 3,
    name: "N/A",
  },
  {
    id: 4,
    name: "B&M",
  },
  {
    id: 5,
    name: "AT",
  },
];

const findItem = (data, key, value) => {
  return data?.find((item) => item[key] === value);
};

const initialSiteOption = {
  GeoLocCd: "",
  GeoLocName: "",
  SiteLIST: "",
};

export default function CreateUpdateClassRequest() {
  const { t } = useTranslation(["createClassRequest"]);
  const [clearFields, setClearFields] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isUpdateMode = location?.state?.mode === "update";
  const classRequestDetails = useSelector((state) => state.classRequest);

  const selectedParentClient = useSelector((state) => state.parentClientId);

  const [selectedProjects, setSelectedProjects] = useState([]);
  const [siteOptions, setSiteOptions] = useState([]);
  const [selectedSite, setSelectedSite] = useState(initialSiteOption);
  const [stateErrorFlags, setStateErrorFlags] = useState({
    selectedProjects: false,
    selectedSite: false,
    waveNumber: false,
    prodFillGoal: false,
    selectedClassType: false,
    selectedRequestStatus: false,
    rosterProdStartDate: false,
  });
  const [showSelectProject, setShowSelectProject] = useState(false);
  const [searchProject, setSearchProject] = useState("");
  const [projectFoundList, setProjectFoundList] = useState([]);
  const [checkedProjects, setCheckedProjects] = useState([]);
  const [leftProjects, setLeftProjects] = useState([]);
  const [rightProjects, setRightProjects] = useState([]);
  const [projects, setProjects] = useState([]);
  const [waveNumber, setWaveNumber] = useState("");
  const [billable, setBillable] = useState("");
  const [nonBillable, setNonBillable] = useState("");
  const [rosterProdStartDate, setRosterProdStartDate] = useState(null);
  const [selectedClassType, setSelectedClassType] = useState(null);
  const [selectedTrainingProduction, setSelectedTrainingProduction] =
    useState(null);
  const [selectedTrainingClassification, setSelectedTrainingClassification] =
    useState(null);
  const [
    selectedProductionClassification,
    setSelectedProductionClassification,
  ] = useState(null);
  const [selectedOgOption, setSelectedOgOption] = useState(null);
  const [selectedRequestStatus, setSelectedRequestStatus] = useState(
    requestStatusOptions[0],
  );
  const [numberOfClasses, setNumberOfClasses] = useState("");
  const [gpmPoc, setGpmPoc] = useState("");
  const [opsApprovalDate, setOpsApprovalDate] = useState(null);
  const [opsApprover, setOpsApprover] = useState(
    employeeSearchResultinitialState,
  );
  const [rosterLockDate, setRosterLockDate] = useState(null);
  const [classFillGoal, setClassFillGoal] = useState("");
  const [classApprovalDate, setClassApprovalDate] = useState(null);
  const [classApprovalComments, setClassApprovalComments] = useState("");
  const [prodFillGoal, setProdFillGoal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isProjectsExpanded, setIsProjectsExpanded] = useState(false);
  const [resetCounter, setResetCounter] = useState(0);

  const projectsRef = useRef(null);
  const siteRef = useRef(null);
  const waveRef = useRef(null);
  const billableRef = useRef(null);
  const rosterProdStartDateRef = useRef(null);
  const classTypeRef = useRef(null);
  const requestStatusRef = useRef(null);
  const numberOfClassesRef = useRef(null);

  const focusField = (ref) => {
    if (!ref?.current) return;
    ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    // Find the actual input inside the wrapper and focus it
    const input = ref.current.querySelector("input, textarea");
    if (input) input.focus();
  };

  const showSnack = (message, severity) => {
    const obj = {
      open: true,
      message: message,
      severity: severity,
    };
    dispatch(SnackBarStoreAction.updateSnack(obj));
  };

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const resetStates = () => {
    setSelectedProjects([]);
    setSelectedSite(initialSiteOption);
    setStateErrorFlags({
      selectedProjects: false,
      selectedSite: false,
      waveNumber: false,
      prodFillGoal: false,
      selectedClassType: false,
      selectedRequestStatus: false,
      rosterProdStartDate: false,
    });
    setShowSelectProject(false);
    setSearchProject("");
    setProjectFoundList(projects);
    setCheckedProjects([]);
    setLeftProjects(projects);
    setRightProjects([]);
    setWaveNumber("");
    setBillable("");
    setNonBillable("");
    setRosterProdStartDate(null);
    setSelectedClassType(null);
    setSelectedTrainingProduction(null);
    setSelectedTrainingClassification(null);
    setSelectedProductionClassification(null);
    setSelectedOgOption(null);
    setSelectedRequestStatus(requestStatusOptions[0]);
    setNumberOfClasses("");
    setGpmPoc("");
    setOpsApprovalDate(null);
    setOpsApprover(employeeSearchResultinitialState);
    setClearFields((prev) => prev + 1);
    setRosterLockDate(null);
    setClassFillGoal("");
    setClassApprovalDate(null);
    setClassApprovalComments("");
    setProdFillGoal(0);
    setIsProjectsExpanded(false);
  };

  useEffect(() => {
    setRightProjects(selectedProjects);
  }, [selectedProjects]);

  useEffect(() => {
    if (projects.length === 0) return;

    const keyword = searchProject?.toLowerCase() || "";
    const filtered = projects.filter((p) => {
      const isSelected = selectedProjects.some(
        (sp) => sp.projectCode === p.projectCode,
      );
      if (isSelected) return false;

      if (keyword) {
        return (
          p.projectName?.toLowerCase().includes(keyword) ||
          p.projectCode?.toLowerCase().includes(keyword)
        );
      }
      return true;
    });

    setProjectFoundList(filtered);
    setLeftProjects(filtered);
  }, [projects, selectedProjects, searchProject]);

  useEffect(() => {
    if (selectedProjects.length > 0) {
      toggleErrorFlags("selectedProjects", false);
    }
  }, [selectedProjects]);

  const resolvedParentClientId =
    selectedParentClient?.parentClientId ||
    location?.state?.parentClientCode ||
    location?.state?.parentClientId ||
    "";

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        await fetchProjectsData();
        if (cancelled) return;

        setLoading(true);
        const siteLocationsResponse = await getSiteLocatioins();
        if (cancelled) return;

        setLoading(false);
        if (siteLocationsResponse.message === "Success") {
          setSiteOptions(siteLocationsResponse.data);
        }
      } catch (error) {
        if (!cancelled) {
          setLoading(false);
          console.error("Failed to fetch data:", error);
        }
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [resolvedParentClientId]);

  const setUpFieldsFromStore = () => {
    const waveValue = classRequestDetails.wave;
    if (!isStringNullOrEmpty(waveValue)) {
      handleNumberInputs(waveValue, setWaveNumber);
    }
    handleNumberInputs(classRequestDetails.prodFillGoalBillable, setBillable);
    handleNumberInputs(
      classRequestDetails.prodFillGoalNonBillable,
      setNonBillable,
    );
    setProdFillGoal(classRequestDetails.prodFillGoal);
    handleDateInputs(
      classRequestDetails.rosterProdStartDate,
      setRosterProdStartDate,
    );
    setSelectedClassType(classRequestDetails.classType);
    setSelectedTrainingProduction(classRequestDetails.trainingSolution);
    setSelectedTrainingClassification(
      classRequestDetails.trainingClassification,
    );
    setSelectedProductionClassification(
      classRequestDetails.productionClassification,
    );
    setSelectedRequestStatus(classRequestDetails.requestStatus);
    setNumberOfClasses(classRequestDetails.noOfClasses);
    setSelectedOgOption(
      ogOptions?.find((item) => item?.id == classRequestDetails.og),
    );
    setGpmPoc(classRequestDetails.gpmPoc);
    setOpsApprovalDate(classRequestDetails.opsApprovalDate);
    setOpsApprover({
      ...employeeSearchResultinitialState,
      Name: classRequestDetails.opsName,
      OracleId: classRequestDetails.opsApproverOracleId,
    });
    setClassFillGoal(classRequestDetails.classFillGoal);
    setRosterLockDate(classRequestDetails.rosterLockDate);
    setClassApprovalDate(classRequestDetails.classApprovalDate);
    setClassApprovalComments(classRequestDetails.classApprovalComments);
  };

  useEffect(() => {
    if (isUpdateMode) setUpFieldsFromStore();
  }, [classRequestDetails]);

  const setUpSiteFromStore = () => {
    if (
      siteOptions?.length > 0 &&
      !isStringNullOrEmpty(classRequestDetails.site)
    ) {
      setSelectedSite(
        findItem(siteOptions, "GeoLocCd", classRequestDetails.site),
      );
    }
  };

  useEffect(() => {
    if (isUpdateMode) setUpSiteFromStore();
  }, [siteOptions, classRequestDetails.site]);

  const setUpProjectsFromStore = () => {
    if (
      Array.isArray(classRequestDetails.project) &&
      classRequestDetails.project.length > 0
    ) {
      const mappedProjects = classRequestDetails.project.map((proj) => ({
        projectName: proj.name || proj.projectName || "",
        projectCode: proj.code || proj.projectCode || "",
        fullName: proj.fullName || "",
        selected: proj.selected || false,
      }));
      setSelectedProjects(mappedProjects);
      return;
    }

    if (
      projects?.length > 0 &&
      !isStringNullOrEmpty(classRequestDetails.project)
    ) {
      const projectCodesFromStore = classRequestDetails.projectCode?.split(",");
      const selectedProjects = projects?.filter((item) =>
        projectCodesFromStore?.includes(item?.projectCode),
      );
      // const selectedProject = findItem(
      //   projects,
      //   "projectCode",
      //   classRequestDetails.projectCode
      // );
      setSelectedProjects(selectedProjects);
    }
  };

  useEffect(() => {
    if (isUpdateMode) setUpProjectsFromStore();
  }, [projects, classRequestDetails.project]);

  useEffect(() => {
    if (resetCounter > 0) {
      resetStates();
    }
  }, [resetCounter]);

  const setupProjects = (projects) => {
    if (classRequestDetails.projectCode.includes(",")) {
      let availableProjects = classRequestDetails.projectCode.split(",");
      let selectedProjects = projects.filter((el) =>
        availableProjects.includes(el.projectCode),
      );
      setSelectedProjects(selectedProjects);
      setProjectFoundList(
        projects.filter((el) => !availableProjects.includes(el.projectCode)),
      );
    } else {
      let selectedProjects = projects.filter(
        (itm) => itm.projectCode === classRequestDetails.projectCode,
      );
      setSelectedProjects(selectedProjects);
      setProjectFoundList(
        projects.filter(
          (el) => el.projectCode !== classRequestDetails.projectCode,
        ),
      );
    }
  };

  const fetchProjectsData = async () => {
    if (!resolvedParentClientId) {
      console.warn("No parentClientId — skipping project fetch");
      return;
    }

    setLoading(true);
    const projectsResponse = await getProjectDetails(resolvedParentClientId);
    setLoading(false);

    if (projectsResponse.status === true) {
      const allProjects = projectsResponse.data.projectDetails || [];
      setProjects(allProjects);
      setProjectFoundList(allProjects);

      if (!isUpdateMode) {
        dispatch(
          classRequestActions.updateRequestStatus(requestStatusOptions[0]),
        );
        dispatch(classRequestActions.updateOg(ogOptions[0].id));
        dispatch(classRequestActions.updateClassType(classTypeOptions[0]));
      }
    }
  };

  const handleSearchKeyword = (e) => {
    const keyword = e.target.value;
    setSearchProject(keyword);

    if (keyword !== "") {
      const results = projects.filter(
        (obj) =>
          JSON.stringify(obj).toLowerCase().includes(keyword.toLowerCase()) &&
          !selectedProjects.some((sp) => sp.projectCode === obj.projectCode),
      );
      setProjectFoundList(results);
    } else {
      setSearchProject("");
      const filtered = projects.filter(
        (obj) =>
          !selectedProjects.some((sp) => sp.projectCode === obj.projectCode),
      );
      setProjectFoundList(filtered);
    }
  };
  const toggleErrorFlags = (key, value) => {
    if (value === true || (value === false && stateErrorFlags[key] === true)) {
      setStateErrorFlags({ ...stateErrorFlags, [key]: value });
    }
  };

  const not = (a, b) =>
    a.filter((value) => !b.some((v) => v.projectCode === value.projectCode));
  const intersection = (a, b) =>
    a.filter((value) => b.some((v) => v.projectCode === value.projectCode));

  const leftCheckedProjects = intersection(checkedProjects, projectFoundList);
  const rightCheckedProjects = intersection(checkedProjects, selectedProjects);

  const handleToggleProject = (project) => {
    const exsists = checkedProjects.some(
      (p) => p.projectCode === project.projectCode,
    );
    if (exsists) {
      setCheckedProjects(
        checkedProjects.filter((p) => p.projectCode !== project.projectCode),
      );
    } else {
      setCheckedProjects([...checkedProjects, project]);
    }
  };

  const handleMoveAllLeft = () => {
    const updatedLeft = [...leftProjects, ...rightProjects];
    setRightProjects([]);
    setLeftProjects(updatedLeft);
    setCheckedProjects(not(checkedProjects, rightProjects));
    setSelectedProjects([]);
    setProjectFoundList(updatedLeft);

    const filtered = projectFoundList.filter(
      (p) =>
        (p.projectName.toLowerCase().includes(searchProject.toLowerCase()) ||
          p.projectCode.toLowerCase().includes(searchProject.toLowerCase())) &&
        ![].some((r) => r.projectCode === p.projectCode),
    );
    setRightProjects(filtered);
  };

  const handleMoveCheckedLeft = () => {
    setProjectFoundList([...projectFoundList, ...rightCheckedProjects]);
    setSelectedProjects(not(selectedProjects, rightCheckedProjects));
    setCheckedProjects(not(checkedProjects, rightCheckedProjects));
  };

  const handleMoveCheckedRight = () => {
    setSelectedProjects([...selectedProjects, ...leftCheckedProjects]);
    setProjectFoundList(not(projectFoundList, leftCheckedProjects));
    setCheckedProjects(not(checkedProjects, leftCheckedProjects));
  };

  const handleMoveAllRight = () => {
    const updatedRight = [...rightProjects, ...leftProjects];
    setLeftProjects([]);
    setRightProjects(updatedRight);
    setCheckedProjects(not(checkedProjects, leftProjects));
    setSelectedProjects(updatedRight);

    const filtered = projectFoundList.filter(
      (p) =>
        (p.projectName.toLowerCase().includes(searchProject.toLowerCase()) ||
          p.projectCode.toLowerCase().includes(searchProject.toLowerCase())) &&
        !updatedRight.some((r) => r.projectCode === p.projectCode),
    );
    setLeftProjects(filtered);
    setProjectFoundList([]);
  };

  const getTotalProdFillGoal = () => {
    const billableHours = parseFloat(billable) || 0;
    const nonBillableHours = parseFloat(nonBillable) || 0;
    if (billableHours <= 0 && nonBillableHours <= 0 && prodFillGoal > 0) {
      return prodFillGoal;
    } else {
      toggleErrorFlags("prodFillGoal", false);
      return billableHours + nonBillableHours;
    }
  };

  const handleNumberInputs = (value, setStateFunction) => {
    const stringValue = value?.toString();
    const regex = /^\d+(\.\d{0,2})?$/;

    if (stringValue === "" || regex.test(stringValue)) {
      setStateFunction(stringValue);
    } else {
      setStateFunction("");
    }
  };

  const handleDateInputs = (value, setStateFunction) => {
    setStateFunction(value);
  };

  const validateInputs = () => {
    if (selectedProjects?.length === 0) {
      toggleErrorFlags("selectedProjects", true);
      showSnack("Please select Project(s).", "warning");
      setShowSelectProject(true);
      focusField(projectsRef);
      return false;
    }
    if (selectedSite.GeoLocCd === "") {
      toggleErrorFlags("selectedSite", true);
      showSnack("Please select Site.", "warning");
      focusField(siteRef);
      return false;
    }
    if (isStringNullOrEmpty(waveNumber)) {
      toggleErrorFlags("waveNumber", true);
      showSnack("Please enter Wave number.", "warning");
      focusField(waveRef);
      return false;
    }
    if (!isUpdateMode && getTotalProdFillGoal() <= 0) {
      toggleErrorFlags("prodFillGoal", true);
      showSnack("Please enter Prod Fill Goal.", "warning");
      focusField(billableRef);
      return false;
    }
    if (!isUpdateMode && isStringNullOrEmpty(rosterProdStartDate)) {
      toggleErrorFlags("rosterProdStartDate", true);
      showSnack("Please select Roster Prod Start Date", "warning");
      focusField(rosterProdStartDateRef);
      return false;
    }
    if (isStringNullOrEmpty(selectedClassType)) {
      toggleErrorFlags("selectedClassType", true);
      showSnack("Please enter Class type.", "warning");
      focusField(classTypeRef);
      return false;
    }
    if (isStringNullOrEmpty(selectedRequestStatus)) {
      toggleErrorFlags("selectedRequestStatus", true);
      showSnack("Please enter Request Status.", "warning");
      focusField(requestStatusRef);
      return false;
    }
    if (isStringNullOrEmpty(numberOfClasses) || numberOfClasses == "0") {
      toggleErrorFlags("numberOfClasses", true);
      showSnack("Please enter Number of Classes.", "warning");
      focusField(numberOfClassesRef);
      return false;
    }
    return true;
  };

  const navigateBack = () => {
    if (location?.state?.from === "/home/searchrosters") {
      navigate(
        `/home/searchrosters?classRequestId=${location?.state?.classRequestId}&classRosterId=${location?.state?.classRosterId}`,
      );
    } else {
      navigate("/home/searchrequests", {
        state: {
          mode: location?.state?.mode,
          searchResultCriteria: location?.state?.searchResultCriteria,
        },
      });
    }
  };

  const getOpsApproverOracleId = () => {
    if (isStringNullOrEmpty(opsApprover.OracleId)) {
      return isUpdateMode ? classRequestDetails.opsApproverOracleId : "";
    }
    return opsApprover.OracleId;
  };

  const preparePayload = () => ({
    classFillGoal: classFillGoal,
    classType: selectedClassType,
    gpmpoc: gpmPoc,
    hiringBands: classRequestDetails.hiringBands,
    numberOfClasses: numberOfClasses || "",
    productionClassfication: selectedProductionClassification,

    productionFillGoalBillable: billable || 0,
    productionFillGoalNonBillable: nonBillable || 0,
    projectCode: selectedProjects.map((item) => item?.projectCode).join(),
    requestStatus: selectedRequestStatus,
    rosterLockDate: isStringNullOrEmpty(rosterLockDate) ? null : rosterLockDate,
    siteCode: selectedSite.GeoLocCd,
    trainingClassification: selectedTrainingClassification,
    trainingProduction: selectedTrainingProduction,
    wave: waveNumber,
    rosterProdStartDate: isStringNullOrEmpty(rosterProdStartDate)
      ? null
      : rosterProdStartDate,
    onboardingSupportedById: selectedOgOption?.id?.toString(),
    classApprovalDate: isStringNullOrEmpty(classApprovalDate)
      ? null
      : classApprovalDate,
    classApprovalComments: classApprovalComments,
    opsApprovalDate: isStringNullOrEmpty(opsApprovalDate)
      ? null
      : opsApprovalDate,
    OpsApproverOracleId: getOpsApproverOracleId(),
    modifiedBy: localStorage.getItem("User"),
  });
  const handleCreateEdit = async () => {
    if (validateInputs()) {
      const payload = preparePayload();

      let response;
      setLoading(true);
      response = isUpdateMode
        ? await postClassRequest(classRequestDetails.classRequestId, payload)
        : await createClassRequest(payload);

      setLoading(false);
      if (response?.message === "Success") {
        if (!isUpdateMode) {
          resetStates();
        }
        showSnack(
          `Class request ${isUpdateMode ? "updated" : "created"} successfully.`,
          "success",
        );
        navigateBack();
      } else {
        showSnack("Internal error occured", "error");
      }
    }
  };

  const handleReset = () => {
    if (isUpdateMode) {
      setUpFieldsFromStore();
      setUpSiteFromStore();
      setUpProjectsFromStore();
      const restoredProjectCodes = (() => {
        if (
          Array.isArray(classRequestDetails.project) &&
          classRequestDetails.project.length > 0
        ) {
          return classRequestDetails.project.map(
            (proj) => proj.code || proj.projectCode || "",
          );
        }
        return classRequestDetails.projectCode?.split(",") || [];
      })();

      const availableProjects = projects.filter(
        (p) => !restoredProjectCodes.includes(p.projectCode),
      );

      setProjectFoundList(availableProjects);
      setLeftProjects(availableProjects);
      setRightProjects(
        projects.filter((p) => restoredProjectCodes.includes(p.projectCode)),
      );
      setCheckedProjects([]);
      setSearchProject("");
    } else {
      resetStates();
    }
  };

  const getParentClientName = () => {
    if (
      isStringNullOrEmpty(
        classRequestDetails?.parentClientDetails?.ParentClientName,
      )
    ) {
      return "";
    }
    return ` Parent client : ${classRequestDetails?.parentClientDetails?.ParentClientName}`;
  };

  return (
    <>
      {loading && <BackdropComponent />}
      <Paper
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.35)",
          p: 1,
          height: "calc(100vh - 95px)",
        }}
      >
        <Grid container>
          <Grid item xs={2.1}>
            <TextLabel
              text={
                isUpdateMode
                  ? t("mainheading.edit_class_request")
                  : t("mainheading.add_class_request")
              }
              header={true}
              fontSize={20}
            ></TextLabel>
          </Grid>

          <Grid item xs={2} sx={{ pt: 1 }}>
            <TextLabel description fontSize={14} text={getParentClientName()} />
          </Grid>
          <Grid item xs={2.3}></Grid>

          <Grid item xs={0.6}>
            <Tooltip title={prepareChipToolTypeTitle(t("ogTitle"))}>
              <Chip label={t("label.og")} sx={prepareChipStyle("OG")}></Chip>
            </Tooltip>
          </Grid>
          <Grid item xs={0.6}>
            <Tooltip title={prepareChipToolTypeTitle(t("ldTitle"))}>
              <Chip label={t("label.l_d")} sx={prepareChipStyle("LD")}></Chip>
            </Tooltip>
          </Grid>
          <Grid item xs={0.6}>
            <Tooltip title={prepareChipToolTypeTitle(t("wfmTitle"))}>
              <Chip label={t("label.wfm")} sx={prepareChipStyle("WFM")}></Chip>
            </Tooltip>
          </Grid>
          <Grid item xs={0.6} sx={{ pl: 1 }}>
            <Tooltip title={prepareChipToolTypeTitle(t("taTitle"))}>
              <Chip label={t("label.ta")} sx={prepareChipStyle("TA")}></Chip>
            </Tooltip>
          </Grid>
          <Grid item xs={0.6}>
            <Tooltip title={prepareChipToolTypeTitle(t("opsTitle"))}>
              <Chip label={t("label.ops")} sx={prepareChipStyle("OPS")}></Chip>
            </Tooltip>
          </Grid>
          <Grid item xs={0.2}></Grid>

          <Grid item xs={0.8}>
            <CustomButton
              variant="contained"
              sx={{ backgroundColor: "#3299FF" }}
              onClick={handleCreateEdit}
            >
              {isUpdateMode ? "Save" : "Create"}
            </CustomButton>
          </Grid>
          <Grid item xs={0.8}>
            <CustomButton
              variant="outlined"
              sx={{ color: "#3299FF" }}
              onClick={handleReset}
            >
              {"Reset"}
            </CustomButton>
          </Grid>
          <Grid item xs={0.8}>
            <CustomButton
              variant="outlined"
              sx={{ color: "#3299FF" }}
              onClick={() => {
                navigateBack();
              }}
            >
              {"Cancel"}
            </CustomButton>
          </Grid>
          <Grid item xs={12} sx={{ pt: 1 }}>
            <Paper
              elevation={4}
              sx={{
                border: `2px solid ${pillThemeConfig.WFM.primaryColor}`, // your custom border color
                boxShadow: `0px 2px 8px ${hexToRgba(
                  pillThemeConfig.WFM.primaryColor,
                  0.5,
                )}`, // custom shadow color
                padding: 1,
              }}
            >
              <Grid container sx={{ pl: 0.5 }} rowGap={1}>
                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("Project(GWFM)")} :`}
                        dnSync
                        required
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={selectedProjects.length > 0 ? 8 : 0}>
                      {selectedProjects.length > 1 ? (
                        <>
                          {isProjectsExpanded ? (
                            <>
                              {selectedProjects.map((project, idx) => (
                                <Grid item key={`${idx}-${project}`}>
                                  <Typography variant="subtitle1">
                                    {`${project.projectName} (${project.projectCode})`}
                                  </Typography>
                                </Grid>
                              ))}
                              <CustomTooltip
                                title={"Click to collapse"}
                                placement="right"
                                arrow
                              >
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                    color: "#3299FF",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    font: "inherit",
                                  }}
                                  onClick={(e) => {
                                    setIsProjectsExpanded(false);
                                    e.stopPropagation();
                                  }}
                                >
                                  {"All Projects"}
                                </IconButton>
                              </CustomTooltip>
                            </>
                          ) : (
                            <>
                              {`${selectedProjects[0]?.projectName} (${selectedProjects[0]?.projectCode})`}{" "}
                              <CustomTooltip
                                title={t("Click to expand")}
                                placement="right"
                                arrow
                              >
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                    color: "#3299FF",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    font: "inherit",
                                  }}
                                  onClick={(e) => {
                                    setIsProjectsExpanded(true);
                                    e.stopPropagation();
                                  }}
                                >
                                  {`+${selectedProjects.length - 1}`}
                                </IconButton>
                              </CustomTooltip>
                            </>
                          )}
                        </>
                      ) : (
                        selectedProjects
                          ?.map(
                            (project) =>
                              `${project.projectName} (${project.projectCode})`,
                          )
                          .join(", ")
                      )}
                    </Grid>
                    <Grid item xs={4} ref={projectsRef}>
                      <CustomButton
                        variant="outlined"
                        sx={{ color: "#3299FF" }}
                        onClick={() => {
                          setShowSelectProject(true);
                        }}
                      >
                        Select Project(s)
                      </CustomButton>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("Site/Location(GWFM)")} :`}
                        dnSync
                        required
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }} ref={siteRef}>
                      <Autocomplete
                        disablePortal
                        size="small"
                        disableClearable
                        options={siteOptions}
                        value={selectedSite}
                        onChange={(event, value) => {
                          setSelectedSite(value);
                          toggleErrorFlags("selectedSite", false);
                        }}
                        getOptionLabel={(option) =>
                          option.GeoLocName
                            ? `${option.GeoLocName} (${option.GeoLocCd})`
                            : ""
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={stateErrorFlags.selectedSite}
                            placeholder={"Select Site/Location"}
                          />
                        )}
                      ></Autocomplete>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("Wave # (GWFM)")} :`}
                        required
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }} ref={waveRef}>
                      <TextField
                        id="wave-number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={waveNumber}
                        error={stateErrorFlags.waveNumber}
                        type="number"
                        inputProps={{
                          inputMode: "numeric",
                          min: 0,
                          max: 99999999,
                          step: 1,
                          pattern: "\\d*",
                        }}
                        onBlur={() => {
                          const value = parseInt(waveNumber, 10);
                          if (!isNaN(value)) {
                            if (value < 0 || value > 99999999) {
                              toggleErrorFlags("waveNumber", true);
                            } else {
                              setWaveNumber(value.toString());
                              toggleErrorFlags("waveNumber", false);
                            }
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          const regex = /^\d{0,8}$/; // Only allow up to 8 digits
                          if (value === "" || regex.test(value)) {
                            setWaveNumber(value);
                            toggleErrorFlags("waveNumber", false);
                          }
                        }}
                        placeholder={t("Wave # (GWFM)")}
                        InputProps={{
                          endAdornment: waveNumber ? (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="clear input"
                                onClick={() => setWaveNumber("")}
                                edge="end"
                                size="small"
                              >
                                <Clear fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ) : null,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={2.7} sx={{ pr: 2 }} ref={billableRef}>
                      <Grid container>
                        <Grid item xs={12}>
                          {isUpdateMode ? (
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <DataNitivSyncIcon />
                              <Tooltip
                                title="Sum of non-Cancelled rosters"
                                placement="top"
                                arrow
                              >
                                <span>
                                  <TextLabel
                                    text={`${t("Billable")} : *`}
                                    fontSize={12}
                                  />
                                </span>
                              </Tooltip>
                            </Box>
                          ) : (
                            <TextLabel
                              text={`${t("Billable")} : *`}
                              dnSync
                              fontSize={12}
                            />
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            type="number"
                            error={stateErrorFlags.prodFillGoal}
                            inputProps={{ min: 0, readOnly: isUpdateMode }}
                            value={billable}
                            onChange={(e) => {
                              if (isUpdateMode) return;
                              handleNumberInputs(e.target.value, setBillable);
                              toggleErrorFlags("prodFillGoal", false);
                            }}
                            placeholder={t("Billable")}
                            sx={
                              isUpdateMode
                                ? {
                                    "& .MuiInputBase-root": {
                                      backgroundColor: "#f5f5f5",
                                    },
                                  }
                                : {}
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={3.2}>
                      <Grid container>
                        <Grid item xs={12}>
                          {isUpdateMode ? (
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                              }}
                            >
                              <DataNitivSyncIcon />
                              <Tooltip
                                title="Sum of non-Cancelled rosters"
                                placement="top"
                                arrow
                              >
                                <span>
                                  <TextLabel
                                    text={`${t("Non-Billable")} : *`}
                                    fontSize={12}
                                  />
                                </span>
                              </Tooltip>
                            </Box>
                          ) : (
                            <TextLabel
                              text={`${t("Non-Billable")} : *`}
                              dnSync
                              fontSize={12}
                            />
                          )}
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            type="number"
                            error={stateErrorFlags.prodFillGoal}
                            inputProps={{ min: 0, readOnly: isUpdateMode }}
                            value={nonBillable}
                            onChange={(e) => {
                              if (isUpdateMode) return;
                              handleNumberInputs(
                                e.target.value,
                                setNonBillable,
                              );
                              toggleErrorFlags("prodFillGoal", false);
                            }}
                            placeholder={t("Non-Billable")}
                            sx={
                              isUpdateMode
                                ? {
                                    "& .MuiInputBase-root": {
                                      backgroundColor: "#f5f5f5",
                                    },
                                  }
                                : {}
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={5} sx={{ pl: 1 }}>
                      <Grid container>
                        <Grid item xs={12}>
                          <TextLabel
                            text={`${t("Prod Fill Goal(GWFM)")}`}
                            required
                            fontSize={12}
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ pt: 1, pl: 7 }}>
                          <TextLabel
                            fontSize={12}
                            description={true}
                            text={getTotalProdFillGoal()}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {!isUpdateMode && (
                  <Grid item xs={4}>
                    <Grid container>
                      <Grid item xs={12}>
                        <TextLabel
                          text={`${t("Roster Prod Start Date(GWFM)")} :`}
                          required
                          fontSize={12}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sx={{ pr: 3 }}
                        ref={rosterProdStartDateRef}
                      >
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <TextField
                            variant="outlined"
                            placeholder="Roster Prod Start Date"
                            type="date"
                            size="small"
                            value={
                              rosterProdStartDate
                                ? moment(rosterProdStartDate).format(
                                    "YYYY-MM-DD",
                                  )
                                : ""
                            }
                            error={stateErrorFlags.rosterProdStartDate}
                            fullWidth
                            onChange={(e) => {
                              const value = e.target.value;
                              const finalValue =
                                value === ""
                                  ? ""
                                  : moment(value).format("YYYY-MM-DD");
                              handleDateInputs(
                                finalValue,
                                setRosterProdStartDate,
                              );
                              toggleErrorFlags("rosterProdStartDate", false);
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === "Backspace" &&
                                rosterProdStartDate !== ""
                              ) {
                                handleDateInputs("", setRosterProdStartDate);
                                toggleErrorFlags("rosterProdStartDate", false);
                              }
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("Class Type(GWFM)")} :`}
                        dnSync
                        required
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }} ref={classTypeRef}>
                      <Autocomplete
                        disablePortal
                        size="small"
                        disableClearable
                        options={classTypeOptions}
                        value={selectedClassType}
                        onChange={(event, value) => {
                          setSelectedClassType(value);
                          toggleErrorFlags("selectedClassType", false);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={stateErrorFlags.selectedClassType}
                            placeholder={`Select ${t("Class Type(GWFM)")}`}
                          />
                        )}
                      ></Autocomplete>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("Training/Production Solution(GWFM)")} :`}
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }}>
                      <Autocomplete
                        disablePortal
                        size="small"
                        disableClearable
                        options={trainingProductionOptions}
                        value={selectedTrainingProduction}
                        onChange={(event, value) => {
                          setSelectedTrainingProduction(value);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={`Select ${t(
                              "Training/Production Solution(GWFM)",
                            )}`}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("FT/PT Training Classification (GWFM)")} :`}
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }}>
                      <Autocomplete
                        disablePortal
                        size="small"
                        disableClearable
                        options={trainingClassificationOptions}
                        value={selectedTrainingClassification}
                        onChange={(event, value) => {
                          setSelectedTrainingClassification(value);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={`Select ${t(
                              "FT/PT Training Classification (GWFM)",
                            )}`}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t(
                          "FT/PT Production Classification (GWFM)",
                        )} :`}
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }}>
                      <Autocomplete
                        disablePortal
                        size="small"
                        disableClearable
                        options={productionClassificationOptions}
                        value={selectedProductionClassification}
                        onChange={(event, value) => {
                          setSelectedProductionClassification(value);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={`Select ${t(
                              "FT/PT Production Classification (GWFM)",
                            )}`}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={4} sx={{ pr: 1, pt: 1 }}>
            <Paper
              elevation={4}
              sx={{
                border: `2px solid ${pillThemeConfig.LD.primaryColor}`, // your custom border color
                boxShadow: `0px 2px 8px ${hexToRgba(
                  pillThemeConfig.LD.primaryColor,
                  0.5,
                )}`, // custom shadow color
                padding: 1,
              }}
            >
              <Grid container sx={{ pl: 0.5 }} rowGap={1}>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("Request Status")} :`}
                        required
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }} ref={requestStatusRef}>
                      <Autocomplete
                        disablePortal
                        size="small"
                        disableClearable
                        options={requestStatusOptions}
                        value={selectedRequestStatus}
                        onChange={(event, value) => {
                          setSelectedRequestStatus(value);
                          toggleErrorFlags("selectedRequestStatus", false);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={`Select ${t("Request Status")}`}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("Number Of Classes")} :`}
                        required
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }} ref={numberOfClassesRef}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="number"
                        value={numberOfClasses}
                        inputProps={{ min: 0 }}
                        onChange={(e) => {
                          handleNumberInputs(
                            e.target.value,
                            setNumberOfClasses,
                          );
                          toggleErrorFlags("numberOfClasses", false);
                        }}
                        placeholder={t("Number Of Classes")}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={4} sx={{ pl: 1, pt: 1 }}>
            <Paper
              elevation={4}
              sx={{
                border: `2px solid ${pillThemeConfig.OG.primaryColor}`, // your custom border color
                boxShadow: `0px 2px 8px ${hexToRgba(
                  pillThemeConfig.OG.primaryColor,
                  0.5,
                )}`, // custom shadow color
                padding: 1,
              }}
            >
              <Grid container sx={{ pl: 0.5 }} rowGap={1}>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("On-boarding Supported By (OG)")} :`}
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }}>
                      <Autocomplete
                        disablePortal
                        size="small"
                        disableClearable
                        options={ogOptions}
                        value={selectedOgOption}
                        onChange={(event, value) => {
                          setSelectedOgOption(value);
                        }}
                        getOptionLabel={(option) => option?.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={`Select ${t(
                              "On-boarding Supported By (OG)",
                            )}`}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("GPM POC (OG)")} :`}
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={gpmPoc}
                        onChange={(e) => {
                          setGpmPoc(e.target.value);
                        }}
                        placeholder={t("GPM POC (OG)")}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={4} sx={{ pl: 1, pt: 1 }}>
            <Paper
              elevation={4}
              sx={{
                border: `2px solid ${pillThemeConfig.OPS.primaryColor}`, // your custom border color
                boxShadow: `0px 2px 8px ${hexToRgba(
                  pillThemeConfig.OPS.primaryColor,
                  0.5,
                )}`, // custom shadow color
                padding: 1,
              }}
            >
              <Grid container sx={{ pl: 0.5 }} rowGap={1}>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("OpsApprovalDate")} :`}
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <TextField
                          variant="outlined"
                          placeholder={t("OpsApprovalDate")}
                          type="date"
                          size="small"
                          error={stateErrorFlags.opsApprovalDate}
                          value={
                            opsApprovalDate
                              ? moment(opsApprovalDate).format("YYYY-MM-DD")
                              : ""
                          }
                          fullWidth
                          onChange={(e) => {
                            const value = e.target.value;
                            const finalValue =
                              value === ""
                                ? ""
                                : moment(value).format("YYYY-MM-DD");
                            handleDateInputs(finalValue, setOpsApprovalDate);
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Backspace" &&
                              opsApprovalDate !== ""
                            ) {
                              handleDateInputs("", setOpsApprovalDate);
                            }
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel text={`${t("OpsApprover")} :`} fontSize={12} />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }}>
                      <EmployeeSearch
                        placeholder={`Select ${t("OpsApprover")}`}
                        onReset={() => {
                          setOpsApprover(employeeSearchResultinitialState);
                        }}
                        onChange={(value) => {
                          setOpsApprover(value);
                        }}
                        disabled={false}
                        isError={stateErrorFlags.opsApprover}
                        defaultEmployeeName={opsApprover?.OracleId || ""}
                        clearFields={clearFields}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sx={{ pt: 1 }}>
            <Paper
              elevation={4}
              sx={{
                border: `2px solid ${pillThemeConfig.TA.primaryColor}`, // your custom border color
                boxShadow: `0px 2px 8px ${hexToRgba(
                  pillThemeConfig.TA.primaryColor,
                  0.5,
                )}`, // custom shadow color
                padding: 1,
              }}
            >
              <Grid container sx={{ pl: 0.5 }} rowGap={1}>
                <Grid item xs={6}>
                  <Grid container rowGap={0.5}>
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={12}>
                          {isUpdateMode ? (
                            <Tooltip
                              title="Sum of non-Cancelled rosters"
                              placement="top"
                              arrow
                            >
                              <span>
                                <TextLabel
                                  text={`${t("Class Fill Goal(TA)")} : `}
                                  dnSync
                                  fontSize={12}
                                />
                              </span>
                            </Tooltip>
                          ) : (
                            <TextLabel
                              text={`${t("Class Fill Goal(TA)")} : `}
                              dnSync
                              fontSize={12}
                            />
                          )}
                        </Grid>
                        <Grid item xs={12} sx={{ pr: 3 }}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            type="number"
                            inputProps={{ min: 0, readOnly: isUpdateMode }}
                            value={classFillGoal}
                            onChange={(e) => {
                              if (isUpdateMode) return;
                              handleNumberInputs(
                                e.target.value,
                                setClassFillGoal,
                              );
                            }}
                            placeholder={t("Class Fill Goal(TA)")}
                            sx={
                              isUpdateMode
                                ? {
                                    "& .MuiInputBase-root": {
                                      backgroundColor: "#f5f5f5",
                                    },
                                  }
                                : {}
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={12}>
                          <TextLabel
                            text={`${t("Roster Lock Date (TA)")} :`}
                            dnSync
                            fontSize={12}
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ pr: 3 }}>
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                            <TextField
                              variant="outlined"
                              placeholder={t("Roster Lock Date (TA)")}
                              type="date"
                              size="small"
                              value={
                                rosterLockDate
                                  ? moment(rosterLockDate).format("YYYY-MM-DD")
                                  : ""
                              }
                              fullWidth
                              onChange={(e) => {
                                const value = e.target.value;
                                const finalValue =
                                  value === ""
                                    ? ""
                                    : moment(value).format("YYYY-MM-DD");

                                handleDateInputs(finalValue, setRosterLockDate);
                              }}
                              onKeyDown={(e) => {
                                if (
                                  e.key === "Backspace" &&
                                  rosterLockDate !== ""
                                ) {
                                  handleDateInputs("", setRosterLockDate);
                                }
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={12}>
                          <TextLabel
                            text={`${t("Class Approval Date (TA)")} :`}
                            fontSize={12}
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ pr: 3 }}>
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                            <TextField
                              variant="outlined"
                              placeholder={t("Class Approval Date (TA)")}
                              type="date"
                              size="small"
                              error={stateErrorFlags.classApprovalDate}
                              value={
                                classApprovalDate
                                  ? moment(classApprovalDate).format(
                                      "YYYY-MM-DD",
                                    )
                                  : ""
                              }
                              fullWidth
                              onChange={(e) => {
                                const value = e.target.value;
                                const finalValue =
                                  value === ""
                                    ? ""
                                    : moment(value).format("YYYY-MM-DD");
                                handleDateInputs(
                                  finalValue,
                                  setClassApprovalDate,
                                );
                              }}
                              onKeyDown={(e) => {
                                if (
                                  e.key === "Backspace" &&
                                  classApprovalDate !== ""
                                ) {
                                  handleDateInputs("", setClassApprovalDate);
                                }
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={12}>
                      <TextLabel
                        text={`${t("Class Approval Comments (TA)")} :`}
                        fontSize={12}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ pr: 3 }}>
                      <TextField
                        variant="outlined"
                        placeholder={`Max 1000 characters allowed`}
                        size="medium"
                        multiline
                        maxLength="1000"
                        minRows={6}
                        value={classApprovalComments}
                        onChange={(e) => {
                          setClassApprovalComments(e.target.value);
                        }}
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <Dialog
          open={showSelectProject}
          onClose={() => {
            setShowSelectProject(false);
          }}
          maxWidth={"lg"}
        >
          <DialogTitle>
            <Grid container>
              <Grid item xs={11}>
                <TextLabel text={"Select Projects"} header fontSize={14} />
              </Grid>
              <Grid item xs={1}>
                <CustomButton
                  variant="contained"
                  sx={{ backgroundColor: "#3299FF" }}
                  onClick={() => {
                    setShowSelectProject(false);
                  }}
                >
                  Done
                </CustomButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <Grid container sx={{ width: 900 }} rowGap={0.5}>
              <Grid item xs={12} sx={{ pr: 1.5 }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={searchProject}
                  size="small"
                  onChange={handleSearchKeyword}
                  placeholder={"Search project"}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={5}>
                    <Paper
                      elevation={3}
                      sx={{
                        width: "100%",
                        height: 450,
                        maxHeight: 450,
                        overflow: "auto",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                      }}
                    >
                      <List dense>
                        <ListItem
                          sx={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 1,
                            fontWeight: "bold",
                          }}
                        >
                          <TextLabel
                            text={"Availabe Projects"}
                            header
                            fontSize={12}
                          />
                        </ListItem>
                        {projectFoundList.map((project) => {
                          const labelId = `left-${project.projectCode}`;
                          return (
                            <ListItem
                              key={project.projectCode}
                              onClick={() => handleToggleProject(project)}
                            >
                              <ListItemIcon>
                                <Checkbox
                                  checked={checkedProjects.some(
                                    (p) =>
                                      p.projectCode === project.projectCode,
                                  )}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <Tooltip
                                title={`${project.projectName} (${project.projectCode})`}
                                arrow
                              >
                                <ListItemText
                                  sx={{
                                    fontFamily:
                                      "Urbanist, Verdana, Arial, sans-serif",
                                  }}
                                  id={labelId}
                                  primary={`${project.projectName} (${project.projectCode})`}
                                />
                              </Tooltip>
                            </ListItem>
                          );
                        })}
                      </List>
                    </Paper>
                  </Grid>
                  <Grid item xs={0.5}></Grid>
                  <Grid item xs={1}>
                    <Grid container sx={{ pt: 12 }}>
                      <Grid item xs={12} sx={{ p: 1 }}>
                        <Tooltip title="Move all to right" arrow>
                          <CustomButton
                            variant="contained"
                            sx={{
                              backgroundColor: "#3299FF",
                              color: "#FFF",
                            }}
                            onClick={handleMoveAllRight}
                            disabled={leftProjects.length === 0}
                          >
                            ≫
                          </CustomButton>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={12} sx={{ p: 1 }}>
                        <Tooltip title="Move selected to right" arrow>
                          <CustomButton
                            variant="contained"
                            sx={{
                              backgroundColor: "#3299FF",
                              color: "#FFF",
                            }}
                            onClick={handleMoveCheckedRight}
                            disabled={leftCheckedProjects.length === 0}
                          >
                            &gt;
                          </CustomButton>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={12} sx={{ p: 1 }}>
                        <Tooltip title="Move selected to left" arrow>
                          <CustomButton
                            variant="contained"
                            onClick={handleMoveCheckedLeft}
                            sx={{
                              backgroundColor: "#3299FF",
                              color: "#FFF",
                            }}
                            disabled={rightCheckedProjects.length === 0}
                          >
                            &lt;
                          </CustomButton>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={12} sx={{ p: 1 }}>
                        <Tooltip title="Move all to left" arrow>
                          <CustomButton
                            sx={{
                              backgroundColor: "#3299FF",
                              color: "#FFF",
                            }}
                            variant="contained"
                            size="small"
                            onClick={handleMoveAllLeft}
                            disabled={rightProjects.length === 0}
                          >
                            ≪
                          </CustomButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={0.5}></Grid>
                  <Grid item xs={5}>
                    <Paper
                      elevation={3}
                      sx={{
                        width: "100%",
                        height: 450,
                        maxHeight: 450,
                        overflow: "auto",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                      }}
                    >
                      <List dense>
                        <ListItem
                          sx={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 1,
                            fontWeight: "bold",
                          }}
                        >
                          <TextLabel
                            text={"Selected Projects"}
                            header
                            fontSize={12}
                          />
                        </ListItem>

                        {selectedProjects.map((project) => {
                          const labelId = `right-${project.projectCode}`;
                          return (
                            <ListItem
                              key={project.projectCode}
                              onClick={() => handleToggleProject(project)}
                            >
                              <ListItemIcon>
                                <Checkbox
                                  checked={checkedProjects.some(
                                    (p) =>
                                      p.projectCode === project.projectCode,
                                  )}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <Tooltip
                                title={`${project.projectName} (${project.projectCode})`}
                                arrow
                              >
                                <ListItemText
                                  sx={{
                                    fontFamily:
                                      "Urbanist, Verdana, Arial, sans-serif",
                                  }}
                                  id={labelId}
                                  primary={`${project.projectName} (${project.projectCode})`}
                                />
                              </Tooltip>
                            </ListItem>
                          );
                        })}
                      </List>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </Paper>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </>
  );
}
